<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['chartdata'],
  data() {
      return {
          options: {
            
          }
      }
  },
  watch: {
    chartdata() {
      this.renderChart(this.chartdata, this.options);
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options);
  }
}
</script>
